module.exports = __webpack_public_path__ + "src/assets/games/26/116.jpg";